<div
  [ngClass]="getClassColor('info-badge-container', type)"
  class="info-badge-container"
>
  <!-- Badge top -->
  <div class="flex-container-top">
    <div
      [ngClass]="getClassColor('flex-container-left-div', type)"
      class="flex-container-left-div"
    >
      <!-- Icon container   -->
      <div class="icon-container">
        <i
          *ngIf="type === BADGE_TYPE.ERROR"
          class="icon-container--error fas fa-exclamation-triangle"
        ></i>
        <i
          *ngIf="type === BADGE_TYPE.WARNING"
          class="icon-container--warning fas fa-exclamation-triangle"
        ></i>
        <i
          *ngIf="type === BADGE_TYPE.INFO"
          class="icon-container--info fa fa-info-circle"
        ></i>
        <!-- Not defined yet -->
        <i
          *ngIf="type === BADGE_TYPE.SUCCESS"
          class="icon-container--success fa fa-info-circle"
        ></i>
      </div>
      <!--  title container -->
      <div
        class="flex-container-header"
        [class.has-close-icon]="type === BADGE_TYPE.WARNING"
      >
        <span class="flex-container-header-name">{{ header }}</span>
        <span *ngIf="hasDescription" class="flex-container-header-view-detail"
          >Ver detalle del error
          <button
            *ngIf="!displayMessage"
            (click)="this.displayMessage = !this.displayMessage"
          >
            <i class="fas fa-chevron-down"></i>
          </button>
          <button
            *ngIf="displayMessage"
            (click)="this.displayMessage = !this.displayMessage"
          >
            <i class="fas fa-chevron-up"></i>
          </button>
        </span>
      </div>
      <!-- Close Icon -->
      <div *ngIf="type === BADGE_TYPE.WARNING" class="close-icon-container">
        <i
          (click)="closeModal()"
          [mat-dialog-close]
          class="fas fa-times close-icon"
        ></i>
      </div>
    </div>

    <div *ngIf="allowFunction" class="flex-container-reprocess">
      <div class="vertical-line"></div>
      <button (click)="onClickEvent()">
        {{ buttonText }}
        <span class="fas fa-arrow-right"></span>
      </button>
    </div>
  </div>

  <!-- Badge  message -->
  <div *ngIf="displayMessage" class="flex-container-body">
    <span class="subtitle">{{ body }}</span>
  </div>
</div>
